module.exports = __webpack_public_path__ + "img/优医问诊.98cefbbc.png";